export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) {
    useNuxtApp()?.ssrContext?.event?.node?.res?.setHeader('Cache-Control', 'max-age=0')
  }
})
